import { apiService } from '@/services/APIService';

import { rHandler } from '@/plugins/RHandler';

export const DEFAULT_PARAMS = {
  args: [],
  params: {},
  data: {},
  headers: {},
  obs: null,
};

export const objectsRHandler = (url, Model) => ({
  index({ params, obs } = DEFAULT_PARAMS) {
    return rHandler(
      apiService.get(url, params),
      (response) => ({
        response,
        items: response.data.data.map((i) => new Model(i, url)),
      }),
      (error) => ({ error }),
      obs,
    );
  },
  show({ args = [], params, obs } = DEFAULT_PARAMS) {
    const [id] = args;
    return rHandler(
      apiService.get(`${url}/${id}`, params),
      (response) => ({
        response,
        item: new Model(response.data.data, url),
      }),
      (error) => ({ error }),
      obs,
    );
  },
  create({ data, obs } = DEFAULT_PARAMS) {
    return rHandler(
      apiService.post(url, data),
      (response) => ({
        response,
        item: new Model(response.data.data, url),
      }),
      (error) => ({ error }),
      obs,
    );
  },
  update({ args = [], data, obs } = DEFAULT_PARAMS) {
    const [id] = args;
    return rHandler(
      apiService.put(`${url}/${id}`, data),
      (response) => ({
        response,
        item: new Model(response.data.data, url),
      }),
      (error) => ({ error }),
      obs,
    );
  },
  delete({ args = [], data, obs } = DEFAULT_PARAMS) {
    const [id] = args;
    return rHandler(
      apiService.delete(`${url}/${id}`, data),
      (response) => ({ response }),
      (error) => ({ error }),
      obs,
    );
  },
});
